<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-7">
            <b-row class="mb-20">
                  <b-col sm="2">
                    <label>Type</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-select name="branch" v-model="classType" @change="changeClass">
                        <option v-for="item in classTypes" :key="item.value" :value="item.value">{{item.text}}</option>
                      </b-form-select>
                  </b-col>
              </b-row>
          </div>
          <div class="col-sm-5 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control"
                    placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(member)="data">
            <p>{{ data.item.member ? data.item.member.first_name : '-' }} {{ data.item.member ? data.item.member.last_name : '' }}</p>
          </template>
          <template v-slot:cell(personal_training)="data">
            <p>{{ data.item.personal_training ? data.item.personal_training.name : '-' }}</p>
          </template>
          <template v-slot:cell(status_code)="data">
            <b-badge :variant="statusCodes(data.item.status_code)">{{data.item.status_code}}</b-badge>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage" :total-pages="totalPage"
          @page-changed="pageOneChanged" prev-text="Prev" next-text="Next" />
      </div>
    </div>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'

export default {
  name: 'frontend_groupfitness',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      fields: [
        {
          key: 'created_at',
          label: 'Date',
          formatter: (value, key, item) => {
            return moment(value).format('DD MMM YYYY HH:mm:ss')
          },
          sortable: false
        },
        {
          key: 'member',
          label: 'Member',
          sortable: false
        },
        {
          key: 'branch.name',
          label: 'Club',
          sortable: false
        },
        {
          key: 'studio.name',
          label: 'Studio (Class)',
          sortable: false
        },
        {
          key: 'personal_training',
          label: 'Personal Trainer',
          sortable: false
        },
        {
          key: 'menu_type',
          label: 'Menu',
          sortable: false
        },
        {
          key: 'status_code',
          label: 'Status',
          sortable: false
        },
        {
          key: 'device',
          label: 'Device',
          sortable: false
        },
        {
          key: 'message',
          label: 'Note',
          sortable: false
        },
      ],
      classTypes: [
        {
          value: '',
          text: 'All'
        },
        {
          value: 'CLASS',
          text: 'Class'
        },
        {
          value: 'CUTTING',
          text: 'Cutting'
        },
        {
          value: 'GYM',
          text: 'Gym'
        }
      ],
      items: [],
      sortType: 'desc',
      sortBy: 'id',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      classType: ''
    }
  },
  computed: {
    name() {
      return this.$route.name
    }
  },
  methods: {
    changeClass(ev) {
      // console.log(ev)
      this.fetchData()
    },
    statusCodes(status) {
      return (status === 200 || status === '200') ? 'success'
          : (status === 202 || status === 202) ? 'warning' : 'danger'
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked(searchEvent) {
      this.fetchData()
    },
    getBadge(status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount(items) {
      return items.length
    },
    openPage(event) {
      this.$router.push(event)
    },
    parseImg(value) {
      return Auth.apiUrl + 'fitness/v1/img/frontend/pha/' + value
    },
    fetchData() {
      this.loadingActive = true
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('attendance/v1/face_/get_face_Log?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + '&class_type=' + this.classType).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        // console.log('test', response.data.data.rows)
        this.loadingActive = false
      }).catch(error => {
        console.log('error', error)
        this.loadingActive = false
      })
    }
  },
  sockets:{
    connect: function () {
      console.log('socket connected')
    },
    message: function(data) {
      console.log('Socket Connected', data)
    },
    face_log:  function(event) {
      console.log(event)
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
    this.$socket.emit('echo', { msg: 'Success Connected' })
  }
}
</script>

<style></style>
